import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryClusterPageService_GetPageLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_cluster_page/v1/service.grpc.lazy';
import React, {FC} from 'react';
import {StoryClusterPageSkeleton} from './StoryClusterPageSkeleton';
import {
  StoryClusterPageProps,
  StoryClusterPageView,
} from './StoryClusterPageView';
import {useStoryClusterIdFromUrl} from './useStoryClusterIdFromUrl';

export const StoryClusterPage: FC<StoryClusterPageProps> = props => {
  return (
    <DataFetcher
      request={useStoryClusterPage()}
      Error={null}
      View={StoryClusterPageView}
      Loading={StoryClusterPageSkeleton}
      viewProps={props}
    />
  );
};

const useStoryClusterPage = () => {
  const storyClusterId = useStoryClusterIdFromUrl();

  return useGrpcRequest(StoryClusterPageService_GetPageLazy, {
    storyClusterId: storyClusterId!,
  });
};
